<template>
    <div>
        <LabelContactForm :text="labelText" :for="inputName" :require="require"/>
        <Input :placeholder="placeholderInput" :name="inputName" :modelValue="inputValue"/>
    </div>
</template>
<script>
import LabelContactForm from '@/Components/LabelContactForm.vue'
import Input from "@/Components/UI/Form/Input.vue"
export default {
    components: {
        LabelContactForm,
        Input
    },
    props: {
        labelText: String,
        require: Boolean,
        inputName: String,
        placeholderInput: String,
        inputValue: String
    },
    data() {

    }
}
</script>
<style>

</style>
